<div class="register-container">
    <div class="language-switcher-container">
        <on-language-switcher></on-language-switcher>
    </div>
    <div class="card">
        <img
            class="card-img-top"
            src="assets/logo.png"
            alt="{{ 'auth.logo-alt' | translate }}"
        />
        <div class="card-body">
            <h2 class="card-title">{{ 'auth.create-account' | translate }}</h2>
            <on-loading *ngIf="isLoading"></on-loading>
            <on-register-form
                [email]="email"
                [hidden]="isLoading"
                (registerRequested)="Register($event)"
            ></on-register-form>
        </div>
    </div>
</div>
